import { HttpErrorResponse, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpEvent } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { throwError, Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { StorageManagerService } from '../services';
import { AuthenticationService } from '../services/authentication.service';
import { EMPTY } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  modifiedHeader: HttpHeaders;
  constructor(private router: Router, private toastr: ToastrService, private storage: StorageManagerService, private authenticationService: AuthenticationService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const req = request.clone();

    return next.handle(req).pipe(
      retry(0),

      catchError((error: HttpErrorResponse) => {

        if (error.status === 401) {

          this.toastr.error('Http call failed with status 401');
          this.router.navigate(['/error', { message: 'Http call failed with status 401' }]);
        }
        return throwError(error);
      })
    );
  }
}
